// extracted by mini-css-extract-plugin
module.exports = {"small":"styles_small__1Dvt9","medium":"styles_medium__SjomB","large":"styles_large__2dgk0","button":"styles_button__2W_a7 nunito"};